import type React from 'react';

import { ORDER_STATUSES } from 'library/helpers/common/constants';
import type { Order } from 'library/models/shop';

import * as st from './Status.module.scss';

type Props = {
	order: Order;
};

const Status: React.FC<Props> = ({ order }) => {
	const statuses = { ...ORDER_STATUSES };

	type StatusKey = keyof typeof ORDER_STATUSES;

	const getStatus = (): StatusKey => {
		const orderStatus = order.status;
		const transactionStatus = order.transaction?.status;

		if (orderStatus === 'A' && transactionStatus === 'o') {
			return 'P';
		}

		return orderStatus ? (orderStatus as StatusKey) : 'F';
	};

	return (
		<span
			className={st.status}
			style={{ backgroundColor: order.status ? statuses[getStatus()].color : '#FFFFFF' }}
		>
			{order.status ? statuses[getStatus()].title : 'Неизвестен'}
		</span>
	);
};

export default Status;
